import { Stops } from "@/types/trip.types";
import { Coordinates } from "@/types/distance.types";
import VehicleForm from "@/components/vehicle/VehicleForm";
import TripPlanner from "@/components/trip/TripPlanner";
import { Vehicle } from "@/types/vehicle.types";
import FuelCostForm from "../cost/FuelCostForm";

interface VehicleTripPanelProps {
  stops: Stops;
  hoveredStopIndex: number | null;
  isDraggingMarker: boolean;
  tripLoading: boolean;
  addVehicle: (vehicle: Vehicle) => void;
  removeVehicle: (id: number) => void;
  clearVehicles: () => void;
  selectedVehicles: Vehicle[];
  vehicleLoading: boolean;
  setVehicleLoading: (loading: boolean) => void;
  updateStop: (index: number, address: string, coords?: Coordinates) => void;
  addStop: () => void;
  removeStop: (index: number) => void;
  clearStop: (index: number) => void;
  reorderStops: (oldIndex: number, newIndex: number) => void;
  currency: string;
  fuelCost: string;
  setFuelCost: (v: string) => void;
  onClearFuelCost: () => void;
}

export function VehicleTripPanel({
  stops,
  hoveredStopIndex,
  isDraggingMarker,
  tripLoading,
  addVehicle,
  removeVehicle,
  clearVehicles,
  selectedVehicles,
  vehicleLoading,
  setVehicleLoading,
  updateStop,
  addStop,
  removeStop,
  clearStop,
  reorderStops,
  currency,
  fuelCost,
  setFuelCost,
  onClearFuelCost
}: VehicleTripPanelProps) {
  return (
    <div className="left-panel">
      <div className="panel select-vehicle-panel">
        <h2>Select Vehicles...</h2>
        <VehicleForm 
          addVehicle={addVehicle}
          removeVehicle={removeVehicle}
          clearVehicles={clearVehicles}
          selectedVehicles={selectedVehicles}
          vehicleLoading={vehicleLoading}
          setVehicleLoading={setVehicleLoading}
        />
      </div>

      <div className="panel fuel-cost-panel">
        <h2>Enter Fuel Cost...</h2>
        <FuelCostForm 
          currency={currency} 
          fuelCost={fuelCost} 
          setFuelCost={setFuelCost}
          onClear={onClearFuelCost}
        />
      </div>

      <div className="panel choose-route-panel">
        <h2>Choose Route...</h2>
        <TripPlanner
          stops={stops}
          hoveredStopIndex={hoveredStopIndex}
          isDraggingMarker={isDraggingMarker}
          tripLoading={tripLoading}
          onStopChange={updateStop}
          addStop={addStop}
          removeStop={removeStop}
          clearStop={clearStop}
          reorderStops={reorderStops}
        />
      </div>
    </div>
  );
}